export default __webpack_public_path__ + "static/media/P_draw.645ccfd9.PNG";